'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { MicroModuleConfig } from './contentModuleConfig';

/**
 * The tenant's micro module config, for the kind-listing surfaces that
 * consume it ({@code MicroListingLayout}). The portal's micro route layout
 * provides it from the shell's stored config; the studio preview provides
 * it from the editor's live postMessage stream — so an operator sees the
 * same resolution in the admin preview and on the live route.
 *
 * <p>{@code null} = no provider above; consumers fall back to
 * {@code MICRO_DEFAULTS} through {@code resolveMicroListingChrome}.
 */
const MicroModuleConfigContext = createContext<MicroModuleConfig | null>(null);

export function MicroModuleConfigProvider({
  value,
  children,
}: {
  value: MicroModuleConfig | null;
  children: ReactNode;
}) {
  return (
    <MicroModuleConfigContext.Provider value={value}>{children}</MicroModuleConfigContext.Provider>
  );
}

export function useMicroModuleConfig(): MicroModuleConfig | null {
  return useContext(MicroModuleConfigContext);
}
